export const buildArrayLength = length => {
    let l = [];
    for (let index = 0; index < length; index++) {
        l.push(index);
    }
    return l;
};

export const makeQuery = filters => {
    if (!filters) return '';
    return Object.keys(filters)
        .reduce(function (a, k) {
            if (filters[k] !== null && typeof filters[k] !== 'undefined' && filters[k] !== '') {
                a.push(k + '=' + encodeURIComponent(filters[k].toString().trim()));
                return a;
            } else {
                a.push("");
                return a
            }
        }, [])
        .join('&');
};

export const scrolly = (action, event) => {
    let element = event.target;
    if (element.scrollHeight - element.scrollTop === element.clientHeight) {
        action();
    }
};

export const emailIsValid = email => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(email);

export const chassisIsValid = chassis => /^[a-zA-Z0-9]+$/.test(chassis);

export const plateIsValid = plate => /^[a-zA-Z0-9]+$/.test(plate);

export const rutIsValid = completeRut => {
    if (!completeRut) return false;
    let rut = completeRut.replace('-', '');
    rut = rut.replaceAll('.', '');
    let M = 0,
        S = 1;
    let T = rut.slice(0, -1);
    for (; T; T = Math.floor(T / 10)) S = (S + (T % 10) * (9 - (M++ % 6))) % 11;
    let vd = S ? S - 1 : 'K';
    return vd.toString() === rut.slice(-1).toUpperCase();
};

export const complementColor = color => {
    if (color.length === 7 && color.slice(0, 1) === '#') {
        color = color.slice(1);
    }
    return parseInt(color.slice(0, 2), 16) + parseInt(color.slice(2, 4), 16) + parseInt(color.slice(4), 16) > 500
        ? '#262d3d'
        : 'whitesmoke';
};
